/****** choose diamond function ********/
$(document).on("click", ".chooseDiamondLink", function() {
    $('#choose_diamond').addClass('choose_diamond_spinner');

    var diamond_id = $(this).data("diamondid");

    var productSku = []; 
    var proceedFlag = 1;
    jQuery.getJSON('/cart.js', function(cart) {
      if(cart.items != ''){ 
        
        $(cart.items).each(function(index, value) { 
           var str = "-";   
           var sku = value.sku;
  
           if(sku.indexOf(str) != -1){                  
             sku = sku.split('-');
             sku = sku[1];                       
           }else{
             var sku = value.sku;      
           }
                     
           if(sku == diamond_id){
             $('#choose_diamond').removeClass('choose_diamond_spinner');
             proceedFlag = 0;
             event.preventDefault();        
             if(store_lang == 'de'){
               alert("Produkt bereits im Warenkorb. Bitte ändern Sie das Paar Diamant."); 
             }else if(store_lang == 'fr'){
               alert('Produit déjà dans le panier. Veuillez changer de diamant.');
             }else if(store_lang == 'it'){
               alert('Prodotto già nel carrello. Si prega di cambiare il diamante.');
             }else{
               alert("Product already in cart. Please change pair diamond."); 
             }                        
           }                              
         });       
      }
    });
  
    var diamond = [{
        "diamond_id": $(this).data("diamondid"),
        "diamond_certno": $(this).data("certno"),
        "diamond_shape": $(this).data("shape"),
        "diamond_price": $(this).data("price"),
        "diamond_name": $(this).data("name"),
        "diamond_type": $(this).data("type"),
        "size" : $(this).data("carat"),
        "diamond_image": $(this).data("image"),
    }];
  
    setTimeout(function(){    
      if(proceedFlag == 1){   
        localStorage.setItem("earring_diamond", JSON.stringify(diamond));
        localStorage.setItem('disable_ring_add_to_cart' , 0);
        setSteps("diamond");
        $('#choose_diamond').removeClass('choose_diamond_spinner');  
      }     
   }, 800); 
});
/****** end of choose diamond *****/

/******* Choose Setting function start ******/

$(document).on("click", ".choose-setting", function() {      
  
  $("#choose_setting").addClass("choose_setting_spinner");

  var selected_diamond = localStorage.getItem("earring_diamond");
  
  if(selected_diamond != null || selected_diamond != undefined){
    var ring_selected_shape = $("#center_stone").val();
    selected_diamond = JSON.parse(selected_diamond);
    var selected_shape = selected_diamond[0].diamond_shape;
    
    if(selected_shape != ring_selected_shape){
      if(store_lang == 'de'){
        alert("Ausgewähltes Diamantenpaar passt nicht zum Ohrring, bitte wechseln Sie das Diamantenpaar");
      }else if(store_lang == 'fr'){
        alert("Le diamant sélectionné n’est pas compatible avec la bague, veuillez choisir un autre diamant.");
      }else if(store_lang == 'it'){
        alert("Il diamante selezionato non è compatibile con l'anello, si prega di scegliere un altro diamante.");
      }else{
        alert("Selected pair of diamonds can not match with earring, please change the pair of diamonds");
      }
      
      $("#choose_setting").removeClass("choose_setting_spinner");
      return false;
    }
  }

    var setting = [{
        "product_id": $("#product_id").val(),
        "product_handel": $("#product_handel").val(),
        "setting_id": $("#variant_id").val(),
        "setting_name": $("#variant_name").val(),
        "setting_price": $("#variant_price").val(),
        "base_price": $("#base_price").val(),
        "setting_metal_type": $("#setting_metal_type").val(),
        "setting_surface": $("#setting_surface").val(),
        "setting_sku": $("#variant_sku").val(),
        "setting_url": $("#variant_url").val(),
        "stock_num": $("#stock_num").val(),
        "minimum_carat_total_weight": $("#minimum_carat_total_weight").val().replace('ct','').trim(),
        "maximum_carat_total_weight": $("#maximum_carat_total_weight").val().replace('ct','').trim(),
        "setting_type": $("#setting_type").val(),
        "center_stone": $("#center_stone").val(),
        "can_be_match_with": $("#can_be_match_with").val(),
      	"image": $("#stockimg0").attr("src"),
      	"setting_style": $("#setting_style").val(),
        "setting_description":$("#product_description").val(),
        "setting_metafields":$("#product_metafields").val(),
        "setting_media_image_id":$("#varient_media_id").val(),
        "setting_image":$("#setting_image").val(),
    }];
    localStorage.setItem("earring_setting", JSON.stringify(setting));
    localStorage.setItem('disable_ring_add_to_cart' , 0);
    $("#choose_setting").removeClass("choose_setting_spinner");
    setSteps("setting");
});
/******* Choose Setting function end  ******/

/*** set currenct step and redirect to next step start ****/
function setSteps(current_step) { 
    if (localStorage.getItem("earring_setting") && localStorage.getItem("earring_diamond")) {
        localStorage.setItem("earring_step3", "final earring");
        var setting_info = JSON.parse(localStorage.getItem("earring_setting"));      
        var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));
     
      	var diamond_price = (diamond_info[0].diamond_price);      	    
        var final_price = parseInt(setting_info[0].setting_price/100) + diamond_price; 
        localStorage.setItem("final_earring_price", final_price);
        
        var diamond_id = diamond_info[0].diamond_id;
        var setting_id = setting_info[0].product_handel;
        var varient_id = setting_info[0].setting_id;   
        var diamond_type = diamond_info[0].diamond_type;
        window.location.href = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true&products="+diamond_id+"/"+setting_id+"/"+varient_id+"/"+diamond_type; // "/pages/final-earring"      
    } else if (current_step == "diamond" && localStorage.getItem("earring_setting")) {
        localStorage.setItem("earring_step2", "diamond");
        window.location.href = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true" // "/pages/final-earring";       
    } else if (current_step == "setting" && localStorage.getItem("earring_diamond")) {
        localStorage.setItem("earring_step2", "setting");
        window.location.href = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true" //"/pages/final-earring";        
    } else if (current_step == "diamond" && !localStorage.getItem("earring_setting")) {
        localStorage.setItem("earring_step1", "diamond");
        localStorage.setItem("earring_step2", "setting");        
        window.location.href = tps_config.urls.earring_builder_listing+"?setting_select=true";        
    } else if (current_step == "setting" && !localStorage.getItem("earring_diamond")) {
      	localStorage.setItem("earring_step1", "setting");
        localStorage.setItem("earring_step2", "diamond");
        window.location.href = tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true";       
    }
}
/*** set currenct step and redirect to next step end ****/


$(document).ready(function() {
  if((getQueryVariable('diamond_select') || getQueryVariable('setting_select') || getQueryVariable('id') || getQueryVariable('diamond_id') || window.location.pathname.indexOf('products') > -1  ) ){
   
  }else{
    if(localStorage.getItem("earring_setting") || localStorage.getItem("earring_diamond")){
    	localStorage.removeItem("earring_diamond");
        localStorage.removeItem("earring_setting");
        localStorage.removeItem("final_earring_price");
        localStorage.removeItem("ringbuilder_dia_shape");
        localStorage.removeItem("earring_step1");
        localStorage.removeItem("earring_step2");
        localStorage.removeItem("earring_step3");
    
      	window.location.href = tps_config.urls.earring_builder_listing;
    }
   
  } 
});
/*** set currenct step and redirect to next step end ****/

function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  } 
  return false;
}

 $(document).ready(function() {   
      /*** set last updated timestamp of product collection if local storage has 1 hour old product collection then clear collection ****/
      if (localStorage.getItem("earring_last_updated")) {
          var d1 = new Date();
          var d2 = new Date(localStorage.getItem("earring_last_updated"));
          var diff = parseInt(((d1 - d2) / 1000).toString());
          if (diff > 3600) {
              localStorage.clear();
              localStorage.setItem("earring_last_updated", d1);
          }
      } else {
          localStorage.setItem("earring_last_updated", new Date());
      }

      /**** set steps and render steps data start *****/
      var active = '';
      var first_step = '';
      var second_step = '';
     if(store_lang == 'de'){
        if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0)) {
            active = "setting";
            first_step = "setting";
            second_step = "diamond"; 
        } else if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/pages/') == 0)) {
            active = "diamond";
            first_step = "diamond";
            second_step = "setting"; 
        } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "diamond"))) {
            first_step = "diamond";
            second_step = "setting"; 
        } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "setting"))) {
            first_step = "setting";
            second_step = "diamond"; 
        }
       
        if (active == '') {
          if (window.location.pathname.indexOf('/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0) {
            active = "setting";
          } else if (window.location.pathname.indexOf('final-earring') > -1 ) {
            active = "final";
          } else if (window.location.pathname.indexOf('letzter-ohrring') > -1 ) {
            active = "final";
          }else {
            active = "diamond";
          }
        }
     }else if(store_lang == 'fr'){
       if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/fr/products/') == 0 || window.location.pathname.indexOf('/fr/collections/') == 0)) {
            active = "setting";
            first_step = "setting";
            second_step = "diamond"; 
        } else if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/fr/pages/') == 0)) {
            active = "diamond";
            first_step = "diamond";
            second_step = "setting"; 
        } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "diamond"))) {
            first_step = "diamond";
            second_step = "setting"; 
        } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "setting"))) {
            first_step = "setting";
            second_step = "diamond"; 
        }
       
        if (active == '') {
          if (window.location.pathname.indexOf('/fr/products/') == 0 || window.location.pathname.indexOf('/collections/') == 0) {
            active = "setting";
          } else if (window.location.pathname.indexOf('final-earring') > -1 ) {
            active = "final";
          } else if (window.location.pathname.indexOf('letzter-ohrring') > -1 ) {
            active = "final";
          }else {
            active = "diamond";
          }
        }
     }else if(store_lang == 'it'){
       if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/it/products/') == 0 || window.location.pathname.indexOf('/it/collections/') == 0)) {
            active = "setting";
            first_step = "setting";
            second_step = "diamond"; 
        } else if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/it/pages/') == 0)) {
            active = "diamond";
            first_step = "diamond";
            second_step = "setting"; 
        } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "diamond"))) {
            first_step = "diamond";
            second_step = "setting"; 
        } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "setting"))) {
            first_step = "setting";
            second_step = "diamond"; 
        }
       
        if (active == '') {
          if (window.location.pathname.indexOf('/it/products/') == 0 || window.location.pathname.indexOf('/it/collections/') == 0) {
            active = "setting";
          } else if (window.location.pathname.indexOf('final-earring') > -1 ) {
            active = "final";
          } else if (window.location.pathname.indexOf('letzter-ohrring') > -1 ) {
            active = "final";
          }else {
            active = "diamond";
          }
        }
     }else{
        if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/en/products/') == 0 || window.location.pathname.indexOf('/en/collections/') == 0)) {
          active = "setting";
          first_step = "setting";
          second_step = "diamond"; 
        } else if ((localStorage.getItem("earring_step1") == null && localStorage.getItem("earring_step2") == null) && (window.location.pathname.indexOf('/en/pages/') == 0)) {
            active = "diamond";
            first_step = "diamond";
            second_step = "setting"; 
        } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "diamond"))) {
            first_step = "diamond";
            second_step = "setting"; 
        } else if ((localStorage.getItem("earring_step1") && (localStorage.getItem("earring_step1") == "setting"))) {
            first_step = "setting";
            second_step = "diamond"; 
        }
       
        if (active == '') {
          if (window.location.pathname.indexOf('/en/products/') == 0 || window.location.pathname.indexOf('/en/collections/') == 0) {
            active = "setting";
          } else if (window.location.pathname.indexOf('final-earring') > -1 ) {            
            active = "final";
          } else if (window.location.pathname.indexOf('letzter-ohrring') > -1 ) {           
            active = "final";
          }else {
            active = "diamond";
          }
        }
     }     

      //dynamically steps text changes  
      if (first_step == "setting") {
          if(jQuery(window).width() <= 767){
              //in mobile step text changes
              if(store_lang == 'de'){
                $("#step1").html("Fassung");
                $("#step2").html("Diamant");
                $("#step3").html("Vollständiger Ohrring");
              }else if(store_lang == 'fr'){
                $("#step1").html("Monture");
                $("#step2").html("Diamant");
                $("#step3").html("Boucles doreilles completes");
              }else if(store_lang == 'it'){
                $("#step1").html("Montatura");
                $("#step2").html("Diamante");
                $("#step3").html("Orecchini completi");
              }else{
                $("#step1").html("Setting");
                $("#step2").html("Diamond");
                $("#step3").html("Complete Earring");
              }
              //end
          }else{            
            if(store_lang == 'de'){
               $("#step1").html("Wählen Sie Ihren Ohrring");          
               $("#step2").html("Wählen Sie Ihren Diamanten");
            }else if(store_lang == 'fr'){
                $("#step1").html("Choisissez votre monture");          
                $("#step2").html("Choisissez votre diamant");
              }else if(store_lang == 'it'){
                $("#step1").html("Scegli la tua montatura");          
                $("#step2").html("Scegli il tuo diamante");
              }else{
               $("#step1").html("Choose Your Setting");          
               $("#step2").html("Choose Your Diamond");
            }           
          }
          $(".step1").addClass("setting-step");
          $(".step2").addClass("diamond-step");
          $(".step_imgs1").addClass("ring_img");
          $(".step_imgs2").addClass("diamond_img");                   
          $(".step_imgs").removeClass("loading");
      } else {
        if(jQuery(window).width() <= 767){
          
          //in mobile step text changes
          if(store_lang == 'de'){
            $("#step2").html("Fassung");
            $("#step1").html("Diamant");
            $("#step3").html("Vollständiger Ohrring");
          }else if(store_lang == 'fr'){
            $("#step2").html("Monture");
            $("#step1").html("Diamant");
            $("#step3").html("Boucles doreilles completes");   
          }else if(store_lang == 'it'){
             $("#step2").html("Montatura");
            $("#step1").html("Diamante");
            $("#step3").html("Orecchini completi");   
          }else{
            $("#step2").html("Setting");
            $("#step1").html("Diamond");
            $("#step3").html("Complete Earring");
          }
          //end
        }else{     
         
          if(store_lang == 'de'){
            $("#step2").html("Wählen Sie Ihren Ohrring");
            $("#step1").html("Wählen Sie Ihren Diamanten");
          }else if(store_lang == 'fr'){
             $("#step2").html("Choisissez votre monture");
            $("#step1").html("Choisissez votre diamant");   
          }else if(store_lang == 'it'){
             $("#step2").html("Scegli la tua montatura");
            $("#step1").html("Scegli il tuo diamante");   
          }else{
            $("#step2").html("Choose Your Setting");
            $("#step1").html("Choose Your Diamond");
          }
          
        }
          
          $(".step1").addClass("diamond-step");
          $(".step2").addClass("setting-step");
          $(".step_imgs2").addClass("ring_img");
          $(".step_imgs1").addClass("diamond_img");
          $(".step_imgs").removeClass("loading");
      }
      //end
   
      if (first_step == "diamond" && localStorage.getItem("earring_diamond")) {         
          var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));     
          var dia_price = diamond_info[0].diamond_price;   
          var dia_type = diamond_info[0].diamond_type;    

          //steps product name,price, view & change urls
          $('#setting_name').html(diamond_info[0].diamond_name);  
          $("#step1_price").html(''+Shopify.formatMoney(dia_price*100,theme.moneyFormat));                 
          $("#step1_view_href").attr("href", tps_config.urls.earringbuilder_loose_diamond_detail+"?diamond_id="+diamond_info[0].diamond_id+"&diamond_type="+dia_type);
                  
          if(dia_type == 'natural-fancy'){   
              $("#step1_change_href").attr("href", tps_config.urls.earringbuilder_loose_fancy_diamond+"?diamond_select=true");           
          }else if(dia_type == 'lab-white'){            
              $("#step1_change_href").attr("href", tps_config.urls.earringbuilder_lab_diamond+"?diamond_select=true");            
          }else if(dia_type == 'lab-fancy'){            
              $("#step1_change_href").attr("href", tps_config.urls.earringbuilder_lab_fancy_diamond+"?diamond_select=true");           
          }else{            
              $("#step1_change_href").attr("href", tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true");                        
          }        
          $(".step1_details").show();

          //change diamond tab url when diamond selected
          $(".natural_white_link").attr("href", tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true");
          $(".natural_fancy_link").attr("href", tps_config.urls.earringbuilder_loose_fancy_diamond+"?diamond_select=true");
          $(".lab_white_link").attr("href", tps_config.urls.earringbuilder_lab_diamond+"?diamond_select=true");
          $(".lab_fancy_link").attr("href", tps_config.urls.earringbuilder_lab_fancy_diamond+"?diamond_select=true");

          //change setting detail page back to search button url when setting selected
          $("#settingBack-to-search").attr("href", tps_config.urls.earring_builder_listing+"?setting_select=true");
      } else if (second_step == "diamond" && localStorage.getItem("earring_diamond")) {        
          var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));  
          var dia_price = diamond_info[0].diamond_price;
          var dia_type = diamond_info[0].diamond_type;

          //steps product name,price, view & change urls
          $("#diamond_name").html(diamond_info[0].diamond_name+'');
          $("#step2_price").html(''+Shopify.formatMoney(dia_price*100,theme.moneyFormat));
          $("#step2_view_href").attr("href", tps_config.urls.earringbuilder_loose_diamond_detail+"?diamond_id=" + diamond_info[0].diamond_id+"&diamond_type="+dia_type);
           
          if(dia_type == 'natural-white'){       
              $("#step2_change_href").attr("href", tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true");                   
          }else if(dia_type == 'natural-fancy'){          
              $("#step2_change_href").attr("href", tps_config.urls.earringbuilder_loose_fancy_diamond+"?diamond_select=true");            
          }else if(dia_type == 'lab-white'){
              $("#step2_change_href").attr("href", tps_config.urls.earringbuilder_lab_diamond+"?diamond_select=true");            
          }else if(dia_type == 'lab-fancy'){
              $("#step2_change_href").attr("href", tps_config.urls.earringbuilder_lab_fancy_diamond+"?diamond_select=true");            
          }else{            
              $("#step2_change_href").attr("href", tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true");
          }        
          $(".step2_details").show(); 

          //change setting detail page back to search button url when setting selected
          $("#settingBack-to-search").attr("href", tps_config.urls.earring_builder_listing+"?setting_select=true");
      }

      if (first_step == "setting" && localStorage.getItem("earring_setting")) {  
          var setting_info = JSON.parse(localStorage.getItem("earring_setting"));         

          //steps product name,price, view & change urls
          $('#setting_name').html(setting_info[0].setting_name);
          $("#step1_price").html(''+Shopify.formatMoney(setting_info[0].setting_price, theme.moneyFormat));
          $("#step1_view_href").attr("href", setting_info[0].setting_url);
          $("#step1_change_href").attr("href", tps_config.urls.earring_builder_listing+"?setting_select=true");
          $(".step1_details").show();
          
          //change diamond tab url when setting selected
          $(".natural_white_link").attr("href", tps_config.urls.earringbuilder_loose_diamond+"?diamond_select=true");
          $(".natural_fancy_link").attr("href", tps_config.urls.earringbuilder_loose_fancy_diamond+"?diamond_select=true");
          $(".lab_white_link").attr("href", tps_config.urls.earringbuilder_lab_diamond+"?diamond_select=true");
          $(".lab_fancy_link").attr("href", tps_config.urls.earringbuilder_lab_fancy_diamond+"?diamond_select=true"); 
  
          //change setting detail page back to search button url when setting selected
          $("#settingBack-to-search").attr("href", tps_config.urls.earring_builder_listing+"?setting_select=true");        
      } else if (second_step == "setting" && localStorage.getItem("earring_setting")) {    
          var setting_info = JSON.parse(localStorage.getItem("earring_setting"));
          var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));  
                  
          $("#diamond_name").html(setting_info[0].setting_name+'');
          $('#setting_name').html(diamond_info[0].diamond_name);
          $("#step2_price").html(''+Shopify.formatMoney(setting_info[0].setting_price, theme.moneyFormat));     
          $("#step2_view_href").attr("href", setting_info[0].setting_url);          
          $("#step2_change_href").attr("href", tps_config.urls.earring_builder_listing+"?diamond_select=true");                    
          $(".step2_details").show();          
  
          //change setting detail page back to search button url when diamond selected
          $("#settingBack-to-search").attr("href", tps_config.urls.earring_builder_listing+"?setting_select=true");        
      }
      
      $("." + active + "-step").addClass("active");
      if (localStorage.getItem("final_earring_price")) { 
           var setting_info = JSON.parse(localStorage.getItem("earring_setting"));        
           var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));
           var diamondFinal_title = setting_info[0].setting_name+' with '+diamond_info[0].diamond_name;
       
           $("#final_title").html(diamondFinal_title);
           $("#step3_price").html(''+Shopify.formatMoney(localStorage.getItem("final_earring_price")*100, theme.moneyFormat));     
      }
      if (localStorage.getItem("earring_diamond") && localStorage.getItem("earring_setting")) {          
          var setting_info = JSON.parse(localStorage.getItem("earring_setting"));
          var diamond_info = JSON.parse(localStorage.getItem("earring_diamond"));    
          var diamond_id = diamond_info[0].diamond_id;
          var diamond_type = diamond_info[0].diamond_type;
          var setting_id = setting_info[0].product_handel;
          var varient_id = setting_info[0].setting_id;
          var final_view_button_url = tps_config.urls.earring_builder_final_page+"?setting_select=true&diamond_select=true?products="+diamond_id+"/"+setting_id+"/"+varient_id+"/"+diamond_type; // "/pages/final-earring";
               
          if(first_step == 'diamond'){
            $(".tps_reset_filter_diamond").show();
            $(".tps_reset_filter_setting").remove();
          }else{
            $(".tps_reset_filter_diamond").remove();
          }
          $("#step3_view_href").attr("href", final_view_button_url);        
          $(".step3_details").show();
      }

  });
/**** set steps and render steps data end *****/

/**** pendant builder flow start over start *****/
function startOver(step){
  localStorage.clear();
  
  if(step == 'setting'){         
      window.location.href = tps_config.urls.earring_builder_listing+"";         
  }else{
      window.location.href = tps_config.urls.earringbuilder_loose_diamond+"";
  }
}
/**** pendant builder flow start over end *****/